(function editProfileControllerDefinition() {

    'use strict';

    angular.module('Profile')
        .controller('EditProfileController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'userService', '$stateParams', 'authExtend', 'loginService',
            function editProfileController($scope, config, $state, $translate, errors, userService, $stateParams, authExtend, loginService) {

                $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);
                $scope.showImageLoad = authExtend.getOrganizationId() !== '';

                function refresh() {

                    authExtend.refreshToken()
                        .then(function (result) {
                            if (!result) {
                                login.logOut();
                                return;
                            }
                        },
                            function () {
                                login.logOut();
                            });
                };

                loginService.getLogged(true).then(function (result) {
                    $scope.user = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('inicio');
                });

                $scope.save = function () {

                    if (!$scope.userForm.$valid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return loginService.modifyWithImage($scope.user, $scope.fileUploadInfo.selectedFile).then(function () {
                        refresh();
                        $state.go('profile-detail');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("profile-detail");
                };

                $scope.resetFileUpload = function resetFileUploadFn() {
                    $scope.fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('image') > -1) {

                        if ($scope.fileUploadInfo.promise !== null) {
                            $scope.fileUploadInfo.promise.abort();
                            $scope.fileUploadInfo.promise = null;
                        }

                        $scope.fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        $scope.fileUploadInfo.selectedFile = files[0];

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.removeImage = function () {
                    $scope.user.signatureImage = null;
                    $scope.user.signatureImagePath = null;
                    $scope.resetFileUpload();
                };

                $scope.resetFileUpload();

            }
        ]);
})();